/**
 * Convert datetime string (YYYY-MM-DD HH:mm:ss)
 * to US format: MM/DD/YYYY h:mm AM/PM
 *
 * @param {String} dateString
 * @returns {String}
 */
export function formatToUS(dateString) {
	if (!dateString) return '';

	// Safari-safe parsing
	const safeString = dateString.replace(' ', 'T');
	const date = new Date(safeString);

	if (isNaN(date.getTime())) return '';

	return date.toLocaleString('en-US', {
		month: '2-digit',
		day: '2-digit',
		year: 'numeric',
		hour: 'numeric',
		minute: '2-digit',
		hour12: true
	});
}
